// extracted by mini-css-extract-plugin
module.exports = {"accordeonBody":"styles_accordeonBody__2aUZD","boxplotWrapper":"styles_boxplotWrapper__3OYPI","processing":"styles_processing__107D5","height":"styles_height__3vgkp"};